/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateContractPremiumProcessingDataPayloadDto
 */
export interface UpdateContractPremiumProcessingDataPayloadDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateContractPremiumProcessingDataPayloadDto
     */
    noticeOfCancellationPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractPremiumProcessingDataPayloadDto
     */
    financeComment?: string;
}

/**
 * Check if a given object implements the UpdateContractPremiumProcessingDataPayloadDto interface.
 */
export function instanceOfUpdateContractPremiumProcessingDataPayloadDto(value: object): value is UpdateContractPremiumProcessingDataPayloadDto {
    return true;
}

export function UpdateContractPremiumProcessingDataPayloadDtoFromJSON(json: any): UpdateContractPremiumProcessingDataPayloadDto {
    return UpdateContractPremiumProcessingDataPayloadDtoFromJSONTyped(json, false);
}

export function UpdateContractPremiumProcessingDataPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContractPremiumProcessingDataPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'noticeOfCancellationPeriod': json['noticeOfCancellationPeriod'] == null ? undefined : json['noticeOfCancellationPeriod'],
        'financeComment': json['financeComment'] == null ? undefined : json['financeComment'],
    };
}

export function UpdateContractPremiumProcessingDataPayloadDtoToJSON(json: any): UpdateContractPremiumProcessingDataPayloadDto {
    return UpdateContractPremiumProcessingDataPayloadDtoToJSONTyped(json, false);
}

export function UpdateContractPremiumProcessingDataPayloadDtoToJSONTyped(value?: UpdateContractPremiumProcessingDataPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'noticeOfCancellationPeriod': value['noticeOfCancellationPeriod'],
        'financeComment': value['financeComment'],
    };
}

